import { useState } from "react";
import axios from "axios";
import { CheckCircle2, LoaderCircle, Send } from "lucide-react";
import { copy } from "@/content/explordioCopy";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const initialForm = { name: "", email: "", phone: "", subject: "", comment: "", website: "" };

export const ContactForm = ({ onSuccessClose, modal = false }) => {
  const [form, setForm] = useState(initialForm);
  const [status, setStatus] = useState("idle");
  const [error, setError] = useState("");
  const update = (field) => (event) => setForm((current) => ({ ...current, [field]: event.target.value }));
  const reset = () => { setForm(initialForm); setStatus("idle"); setError(""); };

  const submit = async (event) => {
    event.preventDefault(); setStatus("sending"); setError("");
    try {
      await axios.post(`${API}/contact`, { ...form, phone: form.phone || null, subject: form.subject || null });
      setStatus("success"); setForm(initialForm);
    } catch (requestError) {
      setStatus("error");
      setError(requestError.response?.data?.detail || "We couldn’t send your message. Please try again.");
    }
  };

  if (status === "success") return (
    <div className="contact-success" data-testid="contact-success-message">
      <CheckCircle2 aria-hidden="true" />
      <h2 data-testid="contact-success-title">{copy.contact.successTitle}</h2>
      <p data-testid="contact-success-description">{copy.contact.successMessage}</p>
      <button type="button" className="contact-submit" onClick={onSuccessClose || reset} data-testid={modal ? "contact-success-close-button" : "contact-success-action-button"}>{onSuccessClose ? "Close" : "Send another message"}</button>
    </div>
  );

  return (
    <form className="contact-form" onSubmit={submit} data-testid="contact-form">
      <header className="contact-heading" data-testid="contact-form-heading">
        <h2 id={modal ? "contact-modal-title" : "contact-form-title"} data-testid={modal ? "contact-modal-title" : "contact-form-title"}>{copy.contact.title}</h2>
        <p data-testid={modal ? "contact-modal-subtitle" : "contact-form-subtitle"}>{copy.contact.subtitle}</p>
      </header>
      <div className="contact-grid">
        <label className="contact-field"><span>Name</span><input required minLength={2} maxLength={100} value={form.name} onChange={update("name")} autoComplete="name" data-testid="contact-name-input" /></label>
        <label className="contact-field"><span>Email</span><input required type="email" maxLength={254} value={form.email} onChange={update("email")} autoComplete="email" data-testid="contact-email-input" /></label>
        <label className="contact-field"><span>Phone (optional)</span><input type="tel" maxLength={40} value={form.phone} onChange={update("phone")} autoComplete="tel" data-testid="contact-phone-input" /></label>
        <label className="contact-field"><span>Subject (optional)</span><span className="subject-control"><strong data-testid="contact-subject-prefix">Explordio:</strong><input maxLength={120} value={form.subject} onChange={update("subject")} data-testid="contact-subject-input" /></span></label>
      </div>
      <label className="contact-field comment-field"><span>Comment</span><textarea required maxLength={3000} rows={6} value={form.comment} onChange={update("comment")} data-testid="contact-comment-input" /><small data-testid="contact-comment-counter">{form.comment.length.toLocaleString()} / 3,000</small></label>
      <input className="contact-honeypot" tabIndex="-1" autoComplete="off" aria-hidden="true" value={form.website} onChange={update("website")} data-testid="contact-website-honeypot" />
      {error ? <p className="contact-error" role="alert" data-testid="contact-form-error">{error}</p> : null}
      <button className="contact-submit" type="submit" disabled={status === "sending"} data-testid="contact-form-submit-button">{status === "sending" ? <LoaderCircle className="spin" aria-hidden="true" /> : <Send aria-hidden="true" />}{status === "sending" ? copy.contact.sending : copy.contact.send}</button>
    </form>
  );
};